var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:_vm.ctx.state.sidebarTab == 'ai' ? 'selected' : '',attrs:{"data-cy":"tab-ai"},on:{"click":function($event){return _vm.ctx.state.selectTab('ai')}}},[_c('mdi',{attrs:{"robot-outline":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }